import Link from "next/link";
import { Button } from "../atoms/Button";
import { Heading } from "../atoms/Heading";
import Icon from "../atoms/Icon";
import { Card, CardContent } from "../ui/card";
import { resolveLegacyLink } from "@/app/utils/linkUtils";

type Props = {
  iconSrc: string;
  title: string;
  text?: string;
  className?: string;
  style?: React.CSSProperties;
  titleClassName?: string;
  ctaLabel?: string;
  ctaLink?: string;
};

export default function FeatureItem({ iconSrc, title, text, className, ctaLink, titleClassName, style, ctaLabel }: Props) {
  return (
    <Card style={style}
      className={`
        flex flex-col justify-center items-center text-center p-6 bg-transparent border-0 
        ${className ?? ""}
      `}
    >
      <CardContent className="flex flex-col justify-center items-center ">
        <Icon src={iconSrc} size={70} className="mb-4" />
        <Heading
          as="h4"
          className={`font-barlow font-semibold ${titleClassName ?? ""}`}
        >
          {title}
        </Heading>
        {text && (
          <p className="text-center mt-2 text-lg leading-7 font-sans">{text}</p>
        )}
        {ctaLabel && (
          <Link href={resolveLegacyLink(ctaLink)} target="_blank">
            <Button className="bg-muted border-1 mt-3 border-muted-foreground rounded-lg p-6 text-gray-700 text-lg font-medium hover:text-white hover:border-0">
              {ctaLabel}
            </Button>
          </Link>
        )


        }
      </CardContent>
    </Card>
  );
}
